/* istanbul ignore file */
export * from './SearchResultSummary';
